import { Avatar, Divider, Grid } from "@mui/material";
import React, {  useEffect, useState } from "react";
import { PrimeGrayBorderColorButton, StatusStyle } from "../../../Components/MaterialButtonStyle/StyleButton";
// import Profile1 from "../../../Assets/Images/User/Profile1.png";
import RightSideModal from "../../../Components/Modal/RightSideModal";
import { FormatDate } from "../../../Components/Helpers/DateTimeConverter";
import AnswerSheet from "../Modal/AnswerSheet"
import { GetPublicURL } from "../../../Helper/api";
const ComputerBasedTest = ({computeTestDetails, computerBasedModal, setComputerBasedModal, applicationDetail ,CandidateDetail}) => {
  const [AnswerSheetModal,setAnswerSheetModal] = useState(false)

  const ViewResult = ()=>{
    if(applicationDetail?.job_application_uuid){
      window.open(`/computer/result/${applicationDetail.job_application_uuid}`, "_blank")
    }
  }
  const [ProfileURL, setProfileURL] = useState("")
  const GetURL = async (file) => {
    const URLs = await GetPublicURL(file)
    if (URLs) {
      setProfileURL(URLs)
    }
  }
  useEffect(()=>{
    GetURL(CandidateDetail?.applicant_image)
  },[CandidateDetail?.applicant_image])
  return (
    <Grid item >
      <RightSideModal
        open={computerBasedModal}
        setOpen={setComputerBasedModal}
        width={"40%"}
        scroll={true}
        height={"90vh"}

        modalTitle={<h4 className="poppinsSemiBold Text-Prime-Black text-left">
          View Computer Based Test Details
        </h4>}
        modalContent={
          <Grid item lg={12} md={12} sm={12} xs={12} className="px-2">
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2 " alignItems={"center"} justifyContent={"space-between"}>
              <Grid item lg={9} sm={9} md={9} xs={9} container alignItems={"center"}>
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name of the Post Applying for
                    </p>

                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_name ? applicationDetail?.job_name : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Notification Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.notificationNumer ? applicationDetail?.notificationNumer : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Application Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial ? applicationDetail?.application_serial : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.Title ? CandidateDetail?.Title : ""}{CandidateDetail?.Surname ? CandidateDetail.Surname+" "+CandidateDetail.LastName : "--"}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={2} sm={2} md={2} xs={2} container justifyContent={"flex-end"}>
                {/* {ProfileURL && <img src={ProfileURL} alt="PSCLogo" height={150} width={150} className="img_fluid" />} */}
                {ProfileURL && <Avatar src={ProfileURL} alt="Profile Picture" sx={{ width: 110, height: 110 }} />}
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Computer Based Test Results
                </h5>
                <Grid item className="w-20 mx-2">
                  <p className={StatusStyle(computeTestDetails?.computer_test_current_status)}>{computeTestDetails?.computer_test_current_status}</p>
                </Grid>
              </Grid>
              <Divider className="my-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />

              <Grid item lg={12} sm={12} md={12} xs={12} >
                <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"center"} justifyContent={"space-between"}>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2 borderBottom">
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Register Number
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left  py-1">
                      {applicationDetail.application_serial ? applicationDetail.application_serial : "--"}
                    </p>

                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2 borderBottom">
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Test Date & Time
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-1">
                      {computeTestDetails?.test_date ? FormatDate(computeTestDetails?.test_date) : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2 borderBottom" >
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Test Venue
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left  py-1">
                      {computeTestDetails?.test_venue ? computeTestDetails?.test_venue : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2 borderBottom" >
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Test Location
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left  py-1">
                      {computeTestDetails?.test_venue ? computeTestDetails?.test_venue : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2 borderBottom">
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Benchmark for Lagos
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left  py-1">
                      {applicationDetail?.benchMark ? applicationDetail?.benchMark : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2 borderBottom">
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Marks Obtained
                    </p>
                    <p className="poppinsRegular Text-Prime-Red text-left  py-1">
                      {computeTestDetails?.total_mark ? computeTestDetails?.total_mark : "0"} out of {computeTestDetails?.allquestions_mark}
                    </p>
                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2" >
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Result Published on
                      </p>
                      <p className="poppinsRegular Text-Prime-Black text-left  py-1">
                        {computeTestDetails?.computer_test_updated_on ? FormatDate(Number(computeTestDetails?.computer_test_updated_on)) : "--"}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container flexDirection={"column"} className="py-2" >
                    <Grid onClick ={(()=>{ViewResult() })} item lg={12} sm={12} md={12} xs={12}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Answer Sheet
                      </p>
                      <p className="poppinsRegular TextUnderGreen pointer text-left  py-1">View</p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setComputerBasedModal(false)}
            >
              Close
            </PrimeGrayBorderColorButton>
          </Grid>
        }
      />
      <AnswerSheet 
        AnswerSheetModal={AnswerSheetModal}
        setAnswerSheetModal={setAnswerSheetModal}

        applicationDetail={applicationDetail}
        heading={`Computer Based Test Answer Key for ${CandidateDetail?.Title} ${CandidateDetail?.Surname} ${CandidateDetail?.LastName} `}
        postName={applicationDetail.job_name}
        year={"2024 - 2025"}
        ApplicationBasicDetails={computeTestDetails}
      />
    </Grid>


  );
};

export default ComputerBasedTest;
